<template>
  <div class="footer-klarna-blurb">
    <div :class="['footer-klarna-blurb__box', `footer-klarna-blurb__box--${variant}`]">
      <img
        src="@/assets/svg/klarna.svg"
        :alt="promotionsContent.klarnaLogoAlt"
        class="footer-klarna-blurb__logo"
      />
      <p class="footer-klarna-blurb__text">
        {{ promotionsContent.klarnaBlurbLead }}
        <span class="footer-klarna-blurb__underline">{{
          promotionsContent.klarnaBlurbEmphasis
        }}</span>
        {{ promotionsContent.klarnaBlurbTail }}
        <a
          :href="infoUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="footer-klarna-blurb__link"
          >{{ promotionsContent.klarnaLearnMoreLabel }}</a
        >.
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'

import { DisclaimerVariant } from '@/components/Shared/AppDisclaimers.vue'

import { promotionsContent } from '@/content/promotions'

export default defineComponent({
  name: 'FooterKlarnaBlurb',
  setup() {
    return {
      promotionsContent,
      infoUrl: import.meta.env.VITE_KLARNA_INFO_URL
    }
  },
  props: {
    // Shares AppDisclaimers' variant enum — AppLayout applies the same dark treatment to both,
    // since they're wrapped together as "everything under the `.app-main` gradient line."
    variant: {
      type: String as PropType<DisclaimerVariant>,
      required: false,
      default: DisclaimerVariant.Default
    }
  }
})
</script>

<style scoped lang="scss">
.footer-klarna-blurb {
  display: flex;
  justify-content: center;
  // No vertical padding — the disclaimer's bottom margin provides the gap above,
  // and this margin provides the gap to the footer below.
  margin-bottom: 1rem;

  @include media-breakpoint-up(md) {
    margin-bottom: 4rem;
  }

  &__box {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    width: 100%;
    max-width: 25rem;
    padding: 1.5rem;
    border-radius: 24px;
    background: #eee;

    &--dark {
      background: #2b2b2b;
    }
  }

  &__logo {
    width: 82px;
    height: auto;
    flex-shrink: 0;
  }

  &__text {
    margin: 0;
    color: #000;
    font-size: 0.875rem;
    line-height: 1.5;

    .footer-klarna-blurb__box--dark & {
      color: #ffffff;
    }
  }

  &__underline,
  &__link {
    text-decoration: underline;
  }

  &__link {
    color: #000;

    .footer-klarna-blurb__box--dark & {
      color: #ffffff;
    }
  }
}
</style>
